import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import Handler from "../../Helpers/Components/Handler"
import PlaceHolder from "../../Helpers/Components/PlaceHolder";
import Modal from "../../Helpers/Components/Modal";
import PageChanger from "../../Helpers/Components/Pagination1";
import { getCookie, reloadWindow } from "../../Helpers/Utils";
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder";
import Select from 'react-select'
import Log from '../../Helpers/Components/Log'

const View = () => {
    const { id } = useParams();
    const [detail, setDetail] = useState({});
    const [loading, setLoading] = useState(false);
    const [pending, setPending] = useState([]);
    const [carPending, setCarPending] = useState({})
    const [modal, setModal] = useState(false);
    const [pageNo, setPage] = useState(1)
    const [next, setNext] = useState(false)
    const [logPageNo, setlogPage] = useState(1)
    const [logNext, setLogNext] = useState(false)
    const navigate = useNavigate()
    const [documentFile, setDocumentFile] = useState({ modal: false })
    const toggle = () => setModal(!modal);
    const [form, setForm] = useState(false)
    const [viewDoc, setViewDoc] = useState()
    const person = getCookie('person')
    const [logLoading, setLogLoading] = useState(false)
    const [log, setLog] = useState([])
    const [count, setCount] = useState(10)
    const [bookingLoading, setBookingLoading] = useState(false)
    const [logCount, setLogCount] = useState(10)

    const getCarLog = async () => {
        setLogLoading(true)
        const carLog = await Handler({ method: 'get', url: `/car/log/${id}?pageNo=${logPageNo}&count=${logCount}` })
        if (carLog?.success) {
            setLog(carLog.data?.list)
            setLogNext(carLog.data?.next)
        } else {
            setLog([])
            setLogNext(false)
        }
        setLogLoading(false)
    }
    const getBooking = async () => {
        setBookingLoading(true)
        const booking = await Handler({ method: 'post', url: `/booking/search/${pageNo}?count=${count || 10}`, data: { carId: id, status: ['Pending'], sortBy: "deliveryDetails.delivery", sort: true } })
        if (booking?.success) {
            setPending(booking?.data?.current);
            setNext(booking?.data?.next)
        } else {
            setPending([])
        }
        setBookingLoading(false)
    }
    const getDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'get', url: `/car/detail/${id}` })
        if (response?.success) {
            setDetail(response?.data);
        } else {
            toast.error(response?.message)
        }
        getBooking()
        setLoading(false)
    }
    const setPageNo = (value) => {
        setPage(value)
    }
    const normalizePendingPhotos = (pendingPhoto) => {
        try {
            if (!Array.isArray(pendingPhoto)) return [];
            if (
                pendingPhoto.length === 1 &&
                typeof pendingPhoto[0] === "string" &&
                pendingPhoto[0].trim().startsWith("[")
            ) {
                try {
                    const parsed = JSON.parse(pendingPhoto[0]);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    return [];
                }
            }
            return pendingPhoto;
        } catch (err) {
            return []
        }
    }
    const downloadFile = async () => {
        try {
            setLoading(true)
            const response = await fetch(viewDoc);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const ext = viewDoc.split(".").pop().split("?")[0];
            link.download = `Car-document.${ext}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false)
        } catch (err) {
            setLoading(false)
            console.error("Download failed", err);
        }
    };
    const handlePending = (element) => {
        const pendingPhotoArray = element?.length ? normalizePendingPhotos(element) : []
        setCarPending(pendingPhotoArray);
        toggle();
    }
    const uploadDocuments = async () => {
        if (!documentFile?.file) {
            toast.error("Upload file")
            return
        }
        setLoading(true)
        const formData = new FormData();
        formData?.append("document", documentFile?.file)
        const response = await Handler({ method: 'POST', url: `/car/documents/upload/${id}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
        if (response?.success) {
            toast.success(response?.message)
            setTimeout(() => {
                reloadWindow()
            }, 1500);
        } else {
            toast.error(response?.message)
            setLoading(false)
        }
    }
    const updateDocuments = async () => {
        if (!documentFile?.file) {
            toast.error("Upload file")
            return
        }
        setLoading(true)
        const formData = new FormData();
        formData?.append("document", documentFile?.file)
        const response = await Handler({ method: 'PATCH', url: `/car/documents/update/${id}?fileId=${documentFile?.fileId}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
        if (response?.success) {
            toast.success(response?.message)
            setTimeout(() => {
                reloadWindow()
            }, 1500);
        } else {
            toast.error(response?.message)
            setLoading(false)
        }
    }
    useEffect(() => {
        if (id) { getDetails() }
    }, [id])
    useEffect(() => {
        if (id) { getBooking() }
    }, [pageNo, count])
    useEffect(() => {
        getCarLog()
    }, [logPageNo, logCount])
    return (
        <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            {!detail?.status && detail?.reason ? <div className="my-3 text-danger text-center fw-bold fs-6">Reason: {detail?.reason || ""}</div> : ""}
            <div className="row my-3 justify-content-center align-items-stretch">
                <div className="col-md-5">
                    <div className="card h-100">
                        <div className="text-center title card-header">
                            Car Photo
                        </div>
                        <div className="d-flex align-items-center justify-content-center card-body">
                            {
                                detail?.photo ?
                                    <img src={detail?.photo} alt="Car" className="carImage" /> : "Photo not available"
                            }
                        </div>
                    </div>
                </div>
                <div className="mt-md-0 mt-3 col-md-5">
                    <div className="card h-100">
                        <div className="text-center title card-header">
                            Car Info
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="card-title form-label"> Car ID </div> </div>
                                <div className="col"><div className="card-text">  {loading ? <PlaceHolder /> : (detail?.carId || "-")} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title form-label"> Model </div> </div>
                                <div className="col"><div className="text-capitalize card-text">  {detail?.model || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title form-label"> Color </div> </div>
                                <div className="col"><div className="text-capitalize card-text">  {detail?.color || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title form-label"> Reg No </div> </div>
                                <div className="col"><div className="card-text">  {detail?.registrationNo || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title form-label"> Fastag Bank </div> </div>
                                <div className="col"><div className="text-capitalize card-text">  {detail?.fasTagType || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="card-title form-label"> Segment </div> </div>
                                <div className="col"><div className="card-text">  {detail?.segment || "-"} </div> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" row my-3 justify-content-center">
                <div className="col-md-10">
                    <div className="card">
                        <div className="text-center card-header title"> Pending History </div>
                        <div className="card-body">
                            <div className="overflow">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="text-center rounded-start">S. No </th>
                                            <th>Booking ID </th>
                                            <th>Customer ID </th>
                                            <th>Customer Name </th>
                                            <th>Status </th>
                                            <th>Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            bookingLoading ? <TablePlaceHolder count={6} /> :
                                                pending?.length > 0 ?
                                                    pending?.map((element, i) => {
                                                        return (
                                                            <tr key={i} id={i} className="align-middle">
                                                                <td className="text-center">{i + 1}</td>
                                                                <td> <a href={`/booking/view/${element?.bookingId}`}>{element?.bookingId}</a></td>
                                                                <td> <a href={`/customer/view/${element?.customerId}`}>{element?.customerId}</a></td>
                                                                <td className="text-capitalize">{(element?.firstName || "") + " " + (element?.lastName || "")}</td>
                                                                <td className="text-capitalize">{(element?.status || "")}</td>
                                                                <td><button className="btn btn-sm btn-theme" onClick={() => handlePending(element?.pendingPhoto || [])}> View </button></td>
                                                            </tr>
                                                        );
                                                    })
                                                    : <tr className="text-center"><td colSpan={7}>No Data Found</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="d-flex align-items-center justify-content-end mt-3">
                                <span className="me-2 fw-medium"> Page Count:  </span>
                                <Select
                                    className="inside-select"
                                    isDisabled={loading}
                                    onChange={(selectedoption) => {
                                        setCount(Number(selectedoption?.value))
                                        setPage(1)
                                    }}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                            "&:hover": {
                                                borderColor: "#f16436"
                                            }
                                        }),
                                        option: (style, state) => ({
                                            ...style,
                                            backgroundColor: state.isSelected
                                                ? "#f16436"
                                                : (state.isFocused || state.isActive)
                                                    ? "#f164361a"
                                                    : "white",
                                            color: state.isSelected ? "white" : "black"
                                        })
                                    }}
                                    value={count ? { label: count, value: count } : { label: 10, value: 10 }}
                                    options={[
                                        { label: 10, value: 10 },
                                        { label: 20, value: 20 },
                                        { label: 30, value: 30 },
                                        { label: 40, value: 40 },
                                        { label: 50, value: 50 },
                                    ]}
                                    placeholder="PageNo"
                                />
                            </div>
                            <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row my-3 justify-content-center">
                <div className="col-md-10">
                    <div className="card">
                        <div className="text-center card-header title"> Documents </div>
                        <div className="card-body">
                            {!detail?.documents || detail?.documents?.length < 10 ?
                                <div className="text-end mb-3">
                                    {!detail?.removed ? <label className="btn btn-sm btn-success" htmlFor="document"><i className="fa-solid fa-upload"></i> Upload</label> : ""}
                                    <input type="file" className="d-none" id="document" accept="image/*, .pdf, application/pdf" onChange={(e) => { setDocumentFile({ modal: true, file: e.target.files[0], url: e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : "" }) }} />
                                </div>
                                : ""}
                            <div className="row">
                                {
                                    detail?.documents?.length ?
                                        detail?.documents?.map((element, key) => {
                                            return (
                                                <div className="col-lg-6 my-3" key={key}>
                                                    <div className=" document-view p-2 rounded-2">
                                                        <div className="main-div">
                                                            <div className="btn-div">
                                                                <label htmlFor={`document${key}`} className="me-2 upload-btn">Update</label>
                                                                <button className="btn-warning btn btn-sm" onClick={() => { setViewDoc(element); setForm(true) }}>View</button>
                                                            </div>
                                                            <input type="file" accept="image/*, .pdf, application/pdf" className="d-none" name={`document${key}`} id={`document${key}`} onChange={(e) => { setDocumentFile({ fileId: key, modal: true, url: e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : "", file: e.target.files[0] }) }} />
                                                            {
                                                                element?.slice(-3) === "pdf"
                                                                    ?
                                                                    <iframe src={`${element}#toolbar=0`} title="Document" className="kycPhotoImg"></iframe>
                                                                    :
                                                                    <img src={element} alt="Document" className="kycPhotoImg" />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                person === "admin" && (logLoading || log?.length > 0 || logPageNo > 1) ? (
                    <div className="row my-3 justify-content-center">
                        <div className="col-md-10">
                            <Log
                                userLog={log}
                                loading={logLoading}
                                pageNo={logPageNo}
                                next={logNext}
                                onPageChange={setlogPage}
                                count={logCount}
                                onCountChange={setLogCount}
                            />
                        </div>
                    </div>
                ) : ""
            }
            <Modal header="Pending Photos" onShow={modal} toggle={toggle} overlayToggle={toggle}>
                <div className="d-flex flex-column align-items-center">
                    {
                        carPending?.length > 0 ?
                            carPending?.map((element) => {
                                return <div className="my-3"><img src={element} alt="Pending" className="pendingImage" /></div>
                            })
                            : <label className="form-label"> No Photos Available </label>
                    }</div>
            </Modal>
            <Modal header="Upload Documents" onShow={documentFile.modal} toggle={() => { setDocumentFile({ modal: false }) }} overlayToggle={() => { setDocumentFile({ modal: false }) }}>
                <div className="modal-body">
                    <div className="document-file">
                        {documentFile?.file?.type === "application/pdf"
                            ?
                            <iframe title="Document" src={documentFile?.url} height={500}></iframe>
                            :
                            <img src={documentFile?.url} alt="Document" />}
                    </div>
                </div>
                <div className="modal-footer d-flex align-items-center justify-content-center gap-1 mt-3">
                    <button className="btn btn-sm btn-success me-2" disabled={loading} onClick={documentFile?.fileId ? updateDocuments : uploadDocuments}>{documentFile?.fileId !== undefined ? "Update" : "Upload"}</button>
                    <button className="btn btn-sm btn-danger" disabled={loading} onClick={() => { setDocumentFile({ modal: false }); reloadWindow() }}>Close</button>
                </div>
            </Modal>
            <Modal header={`Document`} size={"lg"} onShow={form} toggle={() => setForm(false)} overlayToggle={() => setForm(false)}>
                <div className="text-end mb-2"><button className="btn btn-sm p-0" disabled={loading} onClick={downloadFile}><i className="fa-solid fa-download fs-5"></i></button></div>
                <div className="d-flex flex-column align-items-center">
                    <div className="my-3 w-100">
                        {
                            viewDoc?.slice(-3) === "pdf"
                                ?
                                <iframe src={`${viewDoc}#toolbar=0`} title="Document" className="w-100" height={500}></iframe>
                                :
                                <img src={viewDoc} alt="Document" className="w-100" />
                        }
                    </div>
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-danger" onClick={() => setForm(false)}>Cancel</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default View;